'use client';

import { useRem } from '@ssv-website/hooks';

/**
 * 2026 大会页移动端 rem 控制器。
 * 仅在移动端挂载，避免根字号影响 PC 固定稿。
 */
export default function ConferenceMobileRemController() {
  useRem({
    baseWidth: 375,
    baseFontSize: 16,
    minFontSize: 13.65,
    maxFontSize: 18.35,
  });

  return null;
}
